import type { RouteObject } from "react-router"

export const settingsRoutes: RouteObject[] = [
  {
    path: "settings",
    lazy: () => import("./settings-page").then((m) => ({ Component: m.SettingsPage })),
  },
]
